import { DefaultComponentDefinitions, defaultComponentDefinitions } from '@grandvision/bloomreach'

interface BrandComponentDefinitions extends DefaultComponentDefinitions {}

const componentDefinitions: BrandComponentDefinitions = {
  ...defaultComponentDefinitions,
}

export default componentDefinitions
